// variables
import { poiModels } from 'variables';

// libraries
import { atom, atomFamily, selector } from 'recoil';

/** POI 전체 리스트 */
export const PoiAtomFamily = atomFamily({
  key: 'PoiAtomFamily',
  default: []
});

/** POI 리스트를 위한 selector */
export const PoiListSelector = selector({
  key: 'PoiListSelector',
  get: ({ get }) => {
    return get(PoiAtomFamily('all'));
  }
});

/**
 * POI 타입
 */
export const SelectedPoiTypeAtom = atom({
  key: 'SelectedPoiTypeAtom',
  default: undefined
});

/**
 * 선택한 POI 아이템
 */
export const SelectedPoiItemAtom = atom({
  key: 'SelectedPoiItemAtom',
  default: undefined
});

/**
 * 선택한 POI 아이템 스케일
 */
export const SelectedPoiScaleAtom = atom({
  key: 'SelectedPoiScaleAtom',
  default: [1, 1, 1]
});

/**
 * 선택한 POI 아이템 회전
 */
export const SelectedPoiRotationAtom = atom({
  key: 'SelectedPoiRotationAtom',
  default: [1, 1, 1]
});

/*
 * POI 추가 모드
 */
export const PoiAddModeAtom = atom({
  key: 'PoiAddModeAtom',
  default: false
});

/*
 * POI 수정 모드
 * isEditMode : 수정 모드 활성화 여부(기본값: false) - true, false
 * editType : 수정 타입(기본값: undefined) - 'translate', 'rotate', 'scale'
 */
export const PoiEditModeAtom = atom({
  key: 'PoiEditModeAtom',
  default: {
    isEditMode: false,
    editType: undefined,
    editData: undefined
  }
});

/*
 * 선택한 POI JSON 데이터
 */
export const SelectedPoiModelAtom = selector({
  key: 'SelectedPoiModelAtom',
  get: ({ get }) => {
    const selectedPoiType = get(SelectedPoiTypeAtom);

    if (!selectedPoiType) return undefined;

    return poiModels.find((item) => item.key === selectedPoiType);
  }
});
